import { createSelector } from '@reduxjs/toolkit'
import type { State } from '../../Slice/index.js'
import { useGetBlastStatistics } from './GetBlastStatistics.js'
import { projectSlice } from '../../Slice/Project/ProjectSlice.js'

export { useGetBlastStatistics }

// Basic selectors
export const selectProjectState = (state: typeof State) => state.project
export const selectCurrentProject = (state: typeof State) => state.project.currentProject
export const selectCurrentSamples = (state: typeof State) => state.project.currentSamples
export const selectProjects = (state: typeof State) => state.project.projects
export const selectParticipants = (state: typeof State) => state.project.participants
export const selectNotes = (state: typeof State) => state.project.notes
export const selectCreatingProject = (state: typeof State) => state.project.creatingProject
export const selectOpenRequests = (state: typeof State) => state.project.openRequests
export const selectTotal = (state: typeof State) => state.project.total
export const selectBlastStatistics = (state: typeof State) => state.project.blastStatistics
export const selectSamplesLoading = (state: typeof State) => state.project.samplesLoading
export const selectProjectOrders = (state: typeof State) => state.project.projectOrders
export const selectTotalSamples = (state: typeof State) => state.project.totalSamples

// Derived selectors
export const selectProjectById = (projectId: string) =>
  createSelector(selectProjects, (projects) =>
    projects === 'LOADING' ? undefined : projects.find((project) => project.project.id === projectId)
  )

export const selectParticipantsByProjectId = (projectId: string) =>
  createSelector(selectParticipants, (participants) => (participants === 'LOADING' ? 'LOADING' : participants[projectId]))

export const selectNotesByProjectId = (projectId: string) =>
  createSelector(selectNotes, (notes) => (notes === 'LOADING' ? undefined : notes[projectId] || []))

export const selectBlastStatisticsByProjectId = (projectId: string) =>
  createSelector(selectBlastStatistics, (blastStats) => blastStats[projectId] || {})

export const selectAddingProjectSamples = createSelector(selectOpenRequests, (openRequests) =>
  openRequests.includes(projectSlice.actions.addProjectSamplesRequest.type)
)

export const selectIsLoading = createSelector(selectOpenRequests, (openRequests) => openRequests.length > 0)
